module.exports = __webpack_public_path__ + "img/kg.kg3aa9ef9.svg";